import axios from "axios";

import { toast } from "react-toastify";

export const postRequest = async (API_URL, requestData) => {
  console.log("Calling HTTP POST Request....");
  const token=localStorage.getItem('authToken')
  
  const config = {
    headers: {
      "Content-Type": "application/json",
      'Authorization': `Bearer ${token}`
    },
  };
  let response;
  await axios
    .post(API_URL, requestData, config)
    .then((res) => {
      console.log("postRequest res.data ==  ", res.data);
      response = res.data;
    })
    .catch((error) => {
      // console.log(error);
      
      let errorMessage = "An unexpected error occurred.";
      if (error.response) {
        // Server responded with an error status code
        errorMessage = error.response.data.message || `Post Error  ${error.message}`;
      } else if (error.request) {
        // Request was made but no response was received (network issue)
        errorMessage = "No response from the server. Please check your connection.";
      } else {
        // Other errors (e.g., client-side issue)
        errorMessage = error.message;
      }
  
      toast.error(getAxiosErrorMessage(error));
      console.error("Post API Error:", errorMessage);
      console.error("Request URL:", API_URL, "Request Data:", requestData);
    });
  return response;
};
export const getRequest = async (API_URL) => {
  let response;
  console.log("Calling HTTP GET Request....");

  const token = localStorage.getItem("authToken");
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  console.log(token);
  console.log(config);

  await axios
    .get(API_URL, config)
    .then((res) => {
      response = res.data;
    })
    .catch((error) => {
      let errorMessage = "An unexpected error occurred.";

      if (error.response) {
        // ✅ If token invalid, clear it and hard refresh
        if (error.response.status === 401) {
          localStorage.removeItem("authToken");
          window.location.reload(true); // ⬅️ Hard refresh
          return null;
        }

        errorMessage =
          error.response.data.message ||
          `Get Error ${error.message}`;
      } else if (error.request) {
        errorMessage =
          "No response from the server. Please check your connection.";
      } else {
        errorMessage = error.message;
      }

      toast.error(getAxiosErrorMessage(error));
      console.error("Get API Error:", errorMessage);

      return null;
    });

  return response;
};

export const patchRequest = async (API_URL, requestData) => {
  // console.log('Calling HTTP POST Request....')

  const token = localStorage.getItem("authToken");
  const config = {
    headers: {
      "Content-Type": "application/json",
      'Authorization': `Bearer ${token}`
    },
  };
  let response;
  await axios
    .patch(API_URL, requestData, config)
    .then((res) => {
      // console.log('postRequest res ==  ', res);
      // console.log('postRequest res.data ==  ', res.data);

      response = res.status;
    })
    .catch((error) => {
      let errorMessage = "An unexpected error occurred.";

    if (error.response) {
      // Server responded with an error status code
      errorMessage = error.response.data.message || `Patch Error  ${error.message}`;
    } else if (error.request) {
      // Request was made but no response was received (network issue)
      errorMessage = "No response from the server. Please check your connection.";
    } else {
      // Other errors (e.g., client-side issue)
      errorMessage = error.message;
    }

    toast.error(getAxiosErrorMessage(error));
    console.error("Patch API Error:", errorMessage);
    console.error("Request URL:", API_URL, "Request Data:", requestData);

    return null; // Ensure a return value even on failure
    });
  return response;
};
export const deleteRequest = async (API_URL) => {
  // console.log('Calling HTTP POST Request....')

  const token = localStorage.getItem("authToken");
  const config = {
    headers: {
      "Content-Type": "application/json",
      'Authorization': `Bearer ${token}`
    },
  };
  let response;
  await axios
    .delete(API_URL, config)
    .then((res) => {
      response = res.status;
    })
    .catch((error) => {
      toast.error(getAxiosErrorMessage(error));
      console.log("Delelte Api URL while error ===  ", API_URL, "  ");
      console.log("Error caught at service.js file = ", error);
    });
  return response;
};

export const server = {
  // uri: "http://localhost:6006/",
  // uri: "http://3.7.136.155/",
  uri:'https://api.fixupnow.in/'
};

export const customTheme = {
  button: {
    color: "#023E8A",
  },
};

export function getAxiosErrorMessage(error) {
  if (axios.isAxiosError(error)) {
    if (error.response) {
      // Server responded with a status code outside 2xx
      const data = error.response.data;
      if (typeof data === "string") {
        return data;
      }
      if (data?.error?.message) {
        return data.error.message; // LoopBack-style errors
      }
      if (data?.message) {
        return data.message;
      }
      return `Request failed with status ${error.response.status}`;
    } else if (error.request) {
      // Request was made but no response
      return "No response received from server. Please check your connection.";
    } else {
      // Something happened before making the request
      return error.message || "Unknown Axios error occurred.";
    }
  }

  // Not an AxiosError (some other runtime error)
  return (error)?.message || "Unknown error occurred.";
}